import { createRoot } from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import LanguageProvider from './localization/provider/language-provider.tsx';
import createRouter from './routing/router.tsx';
import { RouterProvider } from 'react-router';
import AxiosClientProvider from '../framework/adapter/axios-client-provider.tsx';
import { StrictMode } from 'react';
import { system } from '../ui/theming/valuobject/theme';

/**
 * entry point for react
 */
const rootElement = createRoot(document.getElementById('root')!);

const useStrictMode = import.meta.env.VITE_ENABLE_STRICT_MODE === 'true';

/* eslint-disable react-refresh/only-export-components */
const AppContent = () => (
  <ChakraProvider value={system}>
    <LanguageProvider>
      <AxiosClientProvider>
        <RouterProvider router={createRouter()} />
      </AxiosClientProvider>
    </LanguageProvider>
  </ChakraProvider>
);

if (useStrictMode) {
  rootElement.render(
    <StrictMode>
      <AppContent />
    </StrictMode>,
  );
} else {
  rootElement.render(<AppContent />);
}
